import React, { FC, Dispatch, SetStateAction } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Typography } from '@material-ui/core';
import PeakLogoImg from 'img/icons/peak-logo.png';
import { CustomTheme } from 'common/ui/interfaces';

interface ILoginSelectionProps {
  onSelect: Dispatch<SetStateAction<'client' | 'member' | null>>;
}

const useStyles = makeStyles((theme: CustomTheme) => ({
  headTitle: {
    fontWeight: 900,
    fontSize: '2rem',
    marginBottom: '16px',

    '@media (max-width: 599px)': {
      width: '100%',
      height: '100%',
      marginBottom: '12px',
    },
    '@media (max-width: 399px)': {
      fontSize: '29px',
    },
  },
  title: {
    fontSize: '1.5rem',

    '@media (max-width: 599px)': {
      fontSize: '1.25rem',
    },
  },
  button: {
    color: theme.palette.error.main,
    borderColor: theme.palette.borderColor?.main,
    backgroundColor: theme.palette.background.paper,
    '@media (max-width: 599px)': {
      padding: '14px 45px 14px 45px',
    },
  },
  wrapper: {
    '@media (max-width: 599px)': {
      marginTop: '90px',
      width: '100%',
    },

    '& img': {
      '@media (max-width: 599px)': {
        width: '188px',
      },
    },
  },
  image: {
    marginBottom: '32px',
    '@media (max-width: 599px)': {
      marginBottom: '36px',
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '32px',
    '@media (max-width: 599px)': {
      marginTop: '36px',
      width: '100%',
      justifyContent: 'center',
    },
    '@media (max-width: 399px)': {
      '& button': {
        paddingLeft: '30px',
        paddingRight: '30px',
      },
    },
    '& button+button': { marginLeft: '16px' },
  },

  titleWrapper: {
    '@media (max-width: 599px)': {
      marginLeft: '16px',
    },
  },
}));

const LoginSelection: FC<ILoginSelectionProps> = ({ onSelect }) => {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.titleWrapper}>
        <Box className={classes.image}>
          <img src={PeakLogoImg} alt="test" />
        </Box>
        <Typography className={classes.headTitle}>Peak Payment Solutions</Typography>
        <Typography color="secondary" className={classes.title}>
          {/* Todo: Need to add translations */}
          Billing, Software, Made Easy
        </Typography>
      </Box>
      <Box className={classes.buttonWrapper}>
        <Button variant="outlined" className={classes.button} onClick={() => onSelect('client')}>
          Client login
        </Button>
        <Button variant="outlined" className={classes.button} onClick={() => onSelect('member')}>
          Member login
        </Button>
      </Box>
    </Box>
  );
};

export default LoginSelection;
